module.exports = Jsw.skinUrl + "/icons/16/plesk/file-private.png?b3e618929415e17caa82f8d04d2aa689";